/**
 * Collection Render Fallback
 * Ensures featured collections render even if CSS is delayed
 */

(function() {
  'use strict';

  function ensureCollectionsVisible() {
    // Find all product-list sections
    const productLists = document.querySelectorAll('.section-resource-list, .product-list');
    
    productLists.forEach(section => {
      // Check if section has content but is hidden
      const resourceList = section.querySelector('.resource-list, .resource-list__carousel');
      if (resourceList) {
        const items = resourceList.querySelectorAll('.resource-list__item');
        
        // If items exist but section appears empty, ensure visibility
        if (items.length > 0) {
          // Force display if hidden
          if (window.getComputedStyle(section).display === 'none') {
            section.style.display = 'block';
          }
          if (window.getComputedStyle(resourceList).display === 'none') {
            resourceList.style.display = 'grid';
          }
          
          // Ensure items are visible
          items.forEach(item => {
            if (window.getComputedStyle(item).display === 'none') {
              item.style.display = 'block';
            }
          });
        }
      }
    });
  }

  // Run immediately
  ensureCollectionsVisible();

  // Run after a short delay to catch delayed CSS issues
  setTimeout(ensureCollectionsVisible, 100);
  setTimeout(ensureCollectionsVisible, 500);
  setTimeout(ensureCollectionsVisible, 1000);

  // Also run when CSS loads
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(ensureCollectionsVisible);
  }

  // Watch for dynamically added content
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        shouldCheck = true;
      }
    });
    if (shouldCheck) {
      setTimeout(ensureCollectionsVisible, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
